import ApiService from "./apiService";
import config from "../config/config";
import { apiConfig } from "../config/apiConfig";

class RequestService {
    static instance;

    constructor () {
        if (!RequestService.instance) {
            this.instance = this;
            this.baseUrl = config['backend-url'].endsWith('/') ? config['backend-url'].slice(0, -1) : config['backend-url'];
            this.useToken = true;
            this.dontUseToken = false;
            this.apiService = new ApiService(this.baseUrl);
        }
        return RequestService.instance;
    }

    async updateRequest ( data  ) {
        const response = await this.apiService.post(
            apiConfig.requestTable.updateRequest,
            data,
            this.useToken
        )
        return response;
    }

};

export const requestService = new RequestService();